<template>
  <div class="px-4 m-2 border-2 rounded-md">
    <button
      class="py-4 flex w-full items-center space-x-3"
      @click="toggleAccordion()">
      <slot name="title" />
      <svg
        class="w-3 transition-all duration-200 transform"
        :class="{
          'rotate-180': isOpen,
          'rotate-0': !isOpen,
        }"
        fill="none"
        stroke="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 10">
        <path
          d="M15 1.2l-7 7-7-7"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </button>
    <div
      class="transition-all duration-400 overflow-hidden"
      :class="{
        'max-h-0': !isOpen,
      }">
      <slot name="content" />
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue'

const isOpen = ref(false)

const toggleAccordion = () => {
  isOpen.value = !isOpen.value
}
</script>
